__turbopack_context__.v({
  "boxHeading": "dBK2oG_boxHeading",
  "headline": "dBK2oG_headline",
  "pageB2B": "dBK2oG_pageB2B",
  "submitButton": "dBK2oG_submitButton",
});
